module.exports = __webpack_public_path__ + "img/banner-logo.167c8c9a.png";